import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Badge } from 'antd';

import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function Sales() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);

  const sales = (notifications || []).find(n => n.type === ENotificationType.SALES);
  if (!sales?.quantity) return null;

  return (
    <Link to={`/producer/notifications/${ENotificationType.SALES}`}>
      <div className='flex items-center justify-between px-4 py-2.5 transition-colors hover:bg-[#f5f5f5]'>
        <span className='text-sm font-medium text-[#37474f]'>Vendas realizadas</span>
        <Badge count={sales?.quantity || 0} color='blue' showZero />
      </div>
    </Link>
  );
}
